(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("lib_sitepen_site", [], factory);
	else if(typeof exports === 'object')
		exports["lib_sitepen_site"] = factory();
	else
		root["lib_sitepen_site"] = factory();
})(window, function() {
return 